// extracted by mini-css-extract-plugin
export var elevationBox = "print-module__elevationBox___KrpCj";
export var elevationChart = "print-module__elevationChart___FQt4j";
export var tick = "print-module__tick___QoCM9";
export var xAxisBottom = "print-module__xAxisBottom___avIjL";